let routes = [
    // 煤焦油
    {
        path: 'zetar',
        name: '煤焦油',
        component: () => import('@/views/zetar/index'),
    },
    {
        path: 'zetar/twoPage/industry',
        name: '煤焦油行业动态二级页',
        component: () => import('@/views/zetar/twoPage/industry')
    },
    {
        path: 'zetar/industry',
        name: '煤焦油行业动态详情页',
        component: () => import('@/views/zetar/detail/industry')
    },
    {
        path: 'zetar/twoPage/price',
        name: '煤焦油价格二级页',
        component: () => import('@/views/zetar/twoPage/price')
    },
    {
        path: 'zetar/price',
        name: '煤焦油价格详情页',
        component: () => import('@/views/zetar/detail/price')
    },
    {
        path: 'zetar/backPrice',
        name: '煤焦油后价格详情页',
        component: () => import('@/views/zetar/detail/backPrice')
    },
    {
        path: 'zetar/twoPage/yield',
        name: '煤焦油产量二级页',
        component: () => import('@/views/zetar/twoPage/yield')
    },
    {
        path: 'zetar/yield',
        name: '煤焦油产量详情页',
        component: () => import('@/views/zetar/detail/yield')
    },
    {
        path: 'zetar/twoPage/report',
        name: '煤焦油研究报告二级页',
        component: () => import('@/views/zetar/twoPage/report')
    },
    {
        path: 'zetar/twoPage/rate',
        name: '煤焦油深加工开工率二级页',
        component: () => import('@/views/zetar/twoPage/rate')
    },
    {
        path: 'zetar/rate',
        name: '煤焦油深加工开工率详情页',
        component: () => import('@/views/zetar/detail/rate')
    },
    {
        path: 'zetar/twoPage/profit',
        name: '煤焦油利润二级页',
        component: () => import('@/views/zetar/twoPage/profit')
    },
    {
        path: 'zetar/profit',
        name: '煤焦油利润详情页',
        component: () => import('@/views/zetar/detail/profit')
    },
    {
        path: 'zetar/twoPage/exit',
        name: '煤焦油进出口二级页',
        component: () => import('@/views/zetar/twoPage/exit')
    },
    {
        path: 'zetar/exit',
        name: '煤焦油进出口详情页',
        component: () => import('@/views/zetar/detail/exit')
    },
    {
        path: 'zetar/twoPage/device',
        name: '煤焦油装置动态二级页',
        component: () => import('@/views/zetar/twoPage/device')
    },
    {
        path: 'zetar/device',
        name: '煤焦油装置动态详情页',
        component: () => import('@/views/zetar/detail/device')
    },
    {
        path: 'zetar/twoPage/forecast',
        name: '煤焦油价格预测二级页',
        component: () => import('@/views/zetar/twoPage/forecast')
    },
    {
        path: 'zetar/forecast',
        name: '煤焦油价格预测详情页',
        component: () => import('@/views/zetar/detail/forecast')
    },
    {
        path: 'zetar/twoPage/downPrice',
        name: '煤焦油下游产品价格二级页',
        component: () => import('@/views/zetar/twoPage/downPrice')
    },
    {
        path: 'zetar/downPrice',
        name: '煤焦油下游产品价格详情页',
        component: () => import('@/views/zetar/detail/downPrice')
    },
    {
        path: 'zetar/twoPage/downRate',
        name: '煤焦油下游产品开工率二级页',
        component: () => import('@/views/zetar/twoPage/downRate')
    },
    {
        path: 'zetar/downRate',
        name: '煤焦油下游产品开工率详情页',
        component: () => import('@/views/zetar/detail/downRate')
    },
    {
        path: 'zetar/downRateXin',
        name: '煤焦油下游产品开工率详情页（黑炭）',
        component: () => import('@/views/zetar/detail/downRateXin')
    },
    {
        path: 'zetar/twoPage/downYield',
        name: '煤焦油下游产品产量二级页',
        component: () => import('@/views/zetar/twoPage/downYield')
    },
    {
        path: 'zetar/downYield',
        name: '煤焦油下游产品产量详情页(轮胎)',
        component: () => import('@/views/zetar/detail/downYield')
    },
    {
        path: 'zetar/downYieldXin',
        name: '煤焦油下游产品产量详情页）',
        component: () => import('@/views/zetar/detail/downYieldXin')
    },
    {
        path: 'zetar/twoPage/downExit',
        name: '煤焦油下游产品进出口量二级页',
        component: () => import('@/views/zetar/twoPage/downExit')
    },
    {
        path: 'zetar/downExit',
        name: '煤焦油下游产品进出口量详情页',
        component: () => import('@/views/zetar/detail/downExit')
    },
    {
        path: 'zetar/twoPage/downProfit',
        name: '煤焦油下游产品利润二级页',
        component: () => import('@/views/zetar/twoPage/downProfit')
    },
    {
        path: 'zetar/downProfit',
        name: '煤焦油下游产品利润详情页',
        component: () => import('@/views/zetar/detail/downProfit')
    },
    {
        path: 'zetar/twoPage/standard',
        name: '煤焦油技术及标准二级页',
        component: () => import('@/views/zetar/twoPage/standard')
    },
    {
        path: 'zetar/map',
        name: '煤焦油地图',
        component: () => import('@/views/zetar/detail/map')
    },
]

export default routes;
